import { useState } from 'react';
import { TextStyled, Icon, theme } from '../component-library';
import { useTestContext } from '../context/testContext';
import { helpBoxContent } from '../helpers/helpBoxContent';
import { Flex } from '../2022-component-library';
import { useBreakpoints } from '../helpers/useBreakpoints';
import { ReactComponent as NotesIcon } from '../assets/icons/notes.svg';
import { useNotes } from '../context/notesContext';
import { useAppointment } from '../context/appointmentContext';

const MainPanel = ({ title, helpButton, children, ...props }) => {
  const [showHelpContent, setShowHelpContent] = useState(false);
  const { breakpoints } = useBreakpoints();
  const { userRole } = useAppointment();

  return (
    <Flex
      column
      borderRadius='12px'
      overflow='auto'
      boxShadow='0px 11px 22px #B9D5D5'
      backgroundColor='#fff'
      {...props}
      minHeight='300px'
      minWidth='450px'
      position='relative'
    >
      <Flex
        centered
        width='100%'
        padding={`${breakpoints('8px', '10px', '15px')} 0`}
        style={{ zIndex: 3, position: 'relative', background: theme.colors.primary }}
      >
        <TextStyled color={theme.colors.white} fontWeight='bold' fontSize={breakpoints('14px', '16px', '20px')}>
          {title}
        </TextStyled>
        {helpButton && <HelpButton showHelpContent={showHelpContent} onClick={() => setShowHelpContent(!showHelpContent)} />}
        {props.notesButton && <NotesButton />}
      </Flex>
      <Flex height='100%' centered={userRole === 'patient'}>
        {showHelpContent && <HelpContent />}
        {children}
      </Flex>
    </Flex>
  );
};

export default MainPanel;

const HelpButton = ({ showHelpContent, onClick }) => {
  const { breakpoints } = useBreakpoints();
  return (
    <Flex style={{ position: 'absolute', right: '1rem' }}>
      <Icon
        icon={showHelpContent ? 'icon-close' : 'question'}
        color={showHelpContent ? theme.colors.negativeDark : '#fff'}
        size={breakpoints(20, 25, 30)}
        onClick={onClick}
        hover
      />
    </Flex>
  );
};

const HelpContent = () => {
  const {
    testData: { testKey },
  } = useTestContext();
  return (
    <Flex column centered padding='1rem' backgroundColor='white' overflow='auto' style={{ position: 'absolute', zIndex: 2, inset: 0 }}>
      {testKey?.endsWith('Logmar') ? helpBoxContent['logmar'] : helpBoxContent[testKey]}
    </Flex>
  );
};

const NotesButton = () => {
  const { toggleNotes } = useNotes();
  return (
    <Flex
      onClick={() => toggleNotes()}
      style={{
        backgroundColor: '#fff',
        borderRadius: '50%',
        padding: '0.1rem',
        position: 'absolute',
        left: '1rem',
        fontSize: '1rem',
        cursor: 'pointer',
        boxSizing: 'border-box',
      }}
    >
      <NotesIcon />
    </Flex>
  );
};
